import { usePlatform } from "@/shared/hooks/use-platform";

/**
 * Включён ли помощник на этой платформе (бэкенд отдаёт platform.assistant
 * только включённым). Экраны ошибок (Task 15) показывают по нему кнопку
 * «Разобраться с ...».
 */
export function useAssistantAvailable(): { available: boolean; name: string } {
  const { platform } = usePlatform();
  const assistant = platform?.assistant ?? null;
  return { available: Boolean(assistant), name: assistant?.name ?? "" };
}

/**
 * Имя и аватар помощника для пузыря и панели. Без загруженного площадкой
 * аватара avatarUrl = null: показывается знак «Искры» (AssistantAvatar).
 */
export function useAssistantProfile(): {
  name: string;
  avatarUrl: string | null;
} | null {
  const { platform } = usePlatform();
  const assistant = platform?.assistant ?? null;
  if (!assistant) return null;
  return {
    name: assistant.name,
    avatarUrl: assistant.avatar?.url ?? null,
  };
}
